import { render, staticRenderFns } from "./head-video.vue?vue&type=template&id=37a3e838&scoped=true&"
import script from "./head-video.vue?vue&type=script&lang=ts&"
export * from "./head-video.vue?vue&type=script&lang=ts&"
import style0 from "./head-video.vue?vue&type=style&index=0&id=37a3e838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3e838",
  null
  
)

export default component.exports